import { clsx } from "clsx";
import type { ReactNode } from "react";
import React from "react";

import {
  accordionFooterContent,
  accordionFooterContentExpanded
} from "./Accordion.css";

export type AccordionItemFooterProps = {
  value?: string;
  selectedValue?: string | null;
  expandAll?: boolean;
  children: ReactNode;
};

export const AccordionItemFooter: React.FC<AccordionItemFooterProps> = ({
  value,
  selectedValue,
  expandAll,
  children
}) => {
  const isSelected = expandAll || selectedValue === value;
  return (
    <div
      className={clsx(
        accordionFooterContent,
        isSelected && accordionFooterContentExpanded
      )}
      role="region"
    >
      {children}
    </div>
  );
};
